import { createContext, useState } from "react";

export const MaritalStatusContext = createContext({});

export const Provider = (props) => {
    const { children } = props;

    const [maritalStatuses, setMaritalStatuses] = useState([]);

    // Make the context object:
    const maritalStatusContext = {
        maritalStatuses,
        setMaritalStatuses,
    };

    // pass the value in provider and return
    return <MaritalStatusContext.Provider value={maritalStatusContext}>{children}</MaritalStatusContext.Provider>;
};

export const { Consumer } = MaritalStatusContext;
